import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ImageDirective } from '../../../shared/directives/image.directive';

@Component({
    selector: 'menu-apps, app-menu-apps',
    templateUrl: './apps.component.html',
    styleUrls: ['./apps.component.scss'],
    standalone: true,
    imports: [ImageDirective]
})
export class AppsComponent {

  // List of all applications used for the solution
  apps = [
    {
      name: 'Magento',
      color: 'rgb(236, 103, 55)',
      image: './assets/images/magento.svg',
      url: `${environment.defaultReferenceServer}/admin`
    },
    {
      name: 'WordPress',
      color: 'rgb(32, 114, 151)',
      image: '/assets/images/wordpress.svg',
      url: `${environment.defaultReferenceServer}/wp-login`
    },
    {
      name: 'Blocks',
      color: 'black',
      image: '',
      url: `${environment.defaultReferenceServer}/blocks`
    },
    // {
    //   name: 'Image Manager',
    //   color: 'green',
    //   image: '',
    //   url: `${environment.defaultReferenceServer}/image-manager`
    // },
    // {
    //   name: 'Gloster Product Database',
    //   color: 'lightblue',
    //   image: '',
    //   url: `${environment.defaultReferenceServer}/newAdmin`
    // }
  ]
}
